import { render, staticRenderFns } from "./PedidosFormVista.vue?vue&type=template&id=2bc45f1a"
import script from "./PedidosFormVista.vue?vue&type=script&lang=js"
export * from "./PedidosFormVista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports